<template>
  <v-expansion-panel v-model="panel" expand class="card-height-460" focusable>
    <div v-for="(item, index) in items" :key="item.id">
      <v-expansion-panel-content v-if="item.children && item.children.length > 0" ripple>
        <template slot="header">
          <div class="card-align">
            <input type="radio" name="blockGen" :id="item.id" :checked="activePanel[index][item.id]"
              @click="onClickHandler(item, index, [activePanel, index])" />
            <label :class="activePanel[index][item.id] ? 'selection selection-active' : 'selection'"
              :for="item.id">{{item.name}} : <span :class="activePanel[index][item.id] ? '' : 'number--text'">{{item.gen}} kWh</span>
              </label>
          </div>
        </template>

        <v-card>
          <node v-if="item.children && item.children.length > 0" :items="item.children"
            :active="activePanel[index]['children']"
            @panelSelection="(val) => onClickHandler(...val)">
          </node>
        </v-card>
      </v-expansion-panel-content>
      <expansion-leaf v-else :item="item"></expansion-leaf>
    </div>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'Node',
  components: {
    ExpansionLeaf: () => import('./ExpansionLeaf')
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    },
    active: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      panel: [],
      activePanel: []
    }
  },
  mounted() {
    this.activePanel = this.active
  },
  methods: {
    onClickHandler(item, index) {
      this.activePanel = this.recursiveFunc(this.activePanel, item)
      this.emitSelection(item, index)
    },
    emitSelection(item, index) {
      // Emitting the selected item && index
      this.$emit('panelSelection', [{
        id: item.id,
        level: item.level
      }, index])
    },
    recursiveFunc(arr, item) {
      return arr.map(act => {
        const currentID = item.id.toString().split('-').slice(0, act.depth + 1).join('-')
        if (Object.keys(act)[0] === item.id) {
          act[item.id] = true
        } else {
          if (currentID === Object.keys(act)[0]) {
            act[currentID] = true
          } else {
            act[Object.keys(act)[0]] = false
            if (act.children) {
              act.children = this.recursiveFunc(act.children, item)
            }
          }
        }
        if (act.depth <= item.depth && act.children) {
          act.children = this.recursiveFunc(act.children, item)
        }
        return act
      })
    }
  },
  watch: {
    active() {
      this.activePanel = this.active
    }
  }
}
</script>

<style scoped>
.card-height-460 {
  max-height: 45rem;
  overflow-y: auto;
  background: var(--v-primary-base);
  padding: 0px 10px;
}

input {
  visibility: hidden;
}

.card-align {
  width: 17vw;
}

.selection {
  cursor: pointer;
  padding: 10px 0px;
}

.selection-active {
  color: var(--v-accent-base)
}
</style>
